import React, { useState } from "react";
import { FAQ } from "../../data";
import { Plus, Minus } from "lucide-react";
import SectionHead from "./SectionHead";

export default function Faq() {
  const [open, setOpen] = useState(null);
  const half = Math.ceil(FAQ.length / 2);

  return (
    <section className="sec">
      <div className="mx-auto max-w-[820px] px-4 lg:max-w-[1440px] lg:px-12">
        <SectionHead index="10" title="Domande frequenti" />

        <div className="mt-8 lg:mt-12 lg:grid lg:grid-cols-2 lg:gap-x-14 lg:items-start">
          {[FAQ.slice(0, half), FAQ.slice(half)].map((col, c) => (
            <div key={c} className={c === 0 ? "lg:border-b lg:border-[color:var(--line)]" : ""}>
              {col.map((item, j) => {
                const i = c * half + j;
                const isOpen = open === i;
                return (
                  <div key={i} style={{ borderTop: "1px solid var(--line)" }}>
                    <button
                      onClick={() => setOpen(isOpen ? null : i)}
                      className="w-full flex items-start justify-between gap-4 text-left py-5"
                      aria-expanded={isOpen}
                      data-testid={`faq-question-${i}`}
                    >
                      <span className="ink" style={{ fontSize: "1.08rem", fontWeight: 600 }}>{item.q}</span>
                      <span className="blue shrink-0 mt-1">{isOpen ? <Minus size={20} /> : <Plus size={20} />}</span>
                    </button>
                    {isOpen && (
                      <p className="pb-6" style={{ fontSize: "1.02rem", maxWidth: "62ch" }}>{item.a}</p>
                    )}
                  </div>
                );
              })}
              {c === 1 && <div style={{ borderTop: "1px solid var(--line)" }} />}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
